import SearchSelect from '../../core/SearchSelect';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';
import { withStyles } from '@material-ui/core/styles';
import Tooltip from '@material-ui/core/Tooltip';
import Typography from '@material-ui/core/Typography';
import PropTypes from 'prop-types';
import React from 'react';
import AddButton from '../../core/AddButton';
import CancelButton from '../../core/CancelButton';
import ProjectLanguageSelector from '../../core/ProjectLanguageSelector';
import { computeConceptIcon } from '../../core/utils/utils';
import { globalStyles } from '../../core/style/gstheme';
import TitledPanel from '../../core/TitledPanel';

const styles = Object.assign({}, globalStyles);

class FindRelatedLabelDialog extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            open: false,
            lang: props.defaultLang
        };
        this.cancellable = null;
    }

    changeLanguage = (lang) => this.setState({ lang });

    handleClickOpen = () => this.setState({ open: true });

    computeSearch = (value, lang) => {
        let fullSearch =
        {
            search: [
                {
                    predicate: "http://www.w3.org/1999/02/22-rdf-syntax-ns#type",
                    value: ["http://www.w3.org/2008/05/skos-xl#Label"]
                },
                {
                    predicate: ["http://www.w3.org/2008/05/skos-xl#literalForm"],
                    value: value,
                    isExactMatch: false
                }
            ],
            graph: [this.props.graph],
            exclude: this.props.exclude,
            pageSize: 20,
            language: lang,
            predicates: [
                "https://grafsync.graphifi.com/schema/gs/iri",
                "https://grafsync.graphifi.com/schema/gs/status",
                "http://www.w3.org/2008/05/skos-xl#literalForm"
            ]
        };
        return fullSearch;
    };

    includeLabel = (id) => {
        this.props.onIncludeLabel(id);
        this.exitFindLabel();
    };

    exitFindLabel = () => this.setState({ open: false });

    render() {

        const { classes, exclude, useWorkflow } = this.props;

        return (
            <React.Fragment>
                <AddButton dataTest="add-label-relation" onClick={() => this.handleClickOpen()} title="Add a new label relationship" />
                <Dialog
                    maxWidth="lg"
                    fullWidth
                    classes={{
                        paper: classes.paper,
                        paperWidthLg: classes.largeDialog
                    }}
                    className={classes.dialog} open={this.state.open} onClose={this.exitFindLabel} aria-labelledby="find-label-dialog-title">
                    <DialogTitle data-test="find-label-title" disableTypography className={classes.mainHeading} id="find-label-dialog-title">Find a Label</DialogTitle>
                    <DialogContent style={{ height: 450 }}>
                        <TitledPanel title="Language">
                            <ProjectLanguageSelector includeLabel={false} onSelect={this.changeLanguage} />
                        </TitledPanel>
                        <div style={{ height: 350 }}>
                            <SearchSelect
                                dataTest="related-label"
                                focus={true}
                                exclude={exclude}
                                sortByLength={true}
                                allowEmpty={false}
                                margin={true}
                                search={(value, lang) => this.computeSearch(value, lang)}
                                listSelectionDisplay={(result, lang) => {
                                    if (result.literalForm && result.literalForm[lang]) {
                                        return result.literalForm[lang];
                                    }
                                    else return "No label available";
                                }}
                                listSecondIcon={(result) => computeConceptIcon(result, useWorkflow)}
                                listDisplay={(result, lang) => {
                                    if (result.literalForm && result.literalForm[lang]) {
                                        const currentIRI = result.iri ?
                                            result.iri[result.iri.length - 1]
                                            :
                                            result.id;

                                        return <div>
                                            <Typography data-test="result-text" variant="body2">
                                                <Tooltip
                                                    PopperProps={{
                                                        "data-test": "result-tip"
                                                    }}
                                                    title={currentIRI}>
                                                    <span data-test="result-text-words">
                                                        {result.literalForm[lang]}
                                                    </span>
                                                </Tooltip>
                                            </Typography>
                                            <div data-test="caption">
                                                <Typography variant="caption">SKOS-XL label</Typography>
                                            </div>
                                        </div>;
                                    }
                                    else return "No label available";
                                }}
                                sortProp={["literalForm"]}
                                isClickableResult={(result) => !result.invalid}
                                title="Find a label"
                                lang={this.state.lang}
                                chosen={this.includeLabel} />
                        </div>
                    </DialogContent>
                    <DialogActions className={classes.dialogActions}>
                        <CancelButton onClick={this.exitFindLabel} />
                    </DialogActions>
                </Dialog>
            </React.Fragment>
        );
    }
}

FindRelatedLabelDialog.defaultProps = {
    exclude: [],
    useWorkflow: false
};

FindRelatedLabelDialog.propTypes = {
    classes: PropTypes.object,
    useWorkflow: PropTypes.bool,
    graph: PropTypes.string.isRequired,
    defaultLang: PropTypes.string.isRequired,
    onIncludeLabel: PropTypes.func.isRequired,
    exclude: PropTypes.array,
};

export default withStyles(styles)(FindRelatedLabelDialog);